<template>
  <div>
    <loader v-if="loading"/>
    <ul class="subnavlist">
      <li v-for="projectblock in projectblocks">
        <router-link :to="{ path: '/project/'+projectId+'/projectblock/'+projectblock.id}" class="navlist--item" >
          <span>{{ projectblock.Name}}</span>
        </router-link>
      </li>
      <li>
        <a href="#" class="muted navlist--item" @click="showModal = true">+ Add Block</a>
      </li>
    </ul>
    
    
    <modal v-if="showModal" @close="showModal = false" title="Add a project block">
      <form @submit.prevent="addProjectBlock">
        <transition name="fade">
          <alert-bar v-if="msgtext" v-bind:class="msgclass">{{msgtext}}</alert-bar>
        </transition>
        <input-default label="Name" description="What's your project called" v-model="newProjectBlockName"/>
        <input-default label="Description" v-model="newProjectBlockDesc"/>
        <button class="button" type="submit">Add</button>
      </form>
    </modal>
  </div>
</template>

<script>

  import InputDefault from '../form/InputDefault.vue'
  import AlertBar from '../form/Alert.vue'
  import Loader from '../ui/Loader.vue'
  import Modal from '../modal/Modal.vue'
  import axios from 'axios'

  export default {
    components: {
      Modal,
      InputDefault,
      Loader,
      AlertBar
    },
    props:['projectId'],
    data: function() {
      return{
        msgtext: '',
        msgclass: 'error',
        error: '',
        newProjectBlockName: '',
        newProjectBlockDesc: '',
        showModal: false,
        search: '',
        projectblocks: [],
        loading: true,
        token: JSON.parse(localStorage.getItem('user')).id
      }
    },
    methods: {
      addProjectBlock(){
        const data = {
          Name: this.newProjectBlockName,
          Description: this.newProjectBlockDesc,
          ProjectId: this.projectId
        }

        this.loading = true

        axios.post(process.env.VUE_APP_ROOT_API+'/Projects/'+this.projectId+'/projectblocks?access_token='+this.token, data)
        .then(
          response => this.getProjectBlocks(),
          error => {
            this.msgtext = error,
            this.loading = false
          }
        )
      },
      getProjectBlocks(){

        axios.get(process.env.VUE_APP_ROOT_API+'/Projects/'+this.projectId+'/ProjectBlocks?access_token='+this.token)
        .then(response => {
          this.projectblocks = response.data
          this.loading = false
        })
      }
    },
    mounted(){
      this.getProjectBlocks()
    }
  }

</script>

<style lang="scss">

  #search-person-field{
    width: calc(100% - 20px);
    border-radius: 100px;
    background: rgba(0,0,0,0.07);
    margin: 0 10px 20px;
    padding: .4rem 0 .4rem .6rem;   
    font-size: .9rem; 
  }

  #addPersonName{
    margin-bottom: 20px;
  }

</style>